import React from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import OTableHeadOn from 'components/reusable/OTableHead';
import helpers from 'utils/helpers';
import { useNavigate } from 'react-router-dom';
import { AiFillEye } from 'react-icons/ai';
import ShowCountDown from "components/reusable/ShowCountDown";
import { FaMapMarkerAlt } from 'react-icons/fa';

const OngoingTable = ({ filteredData, sort, setSort, page, tab, type, onComplete }) => {
  const { t } = useTranslation();
  const navigate = useNavigate()


  return (
    <div className="overflow-x-auto relative rounded-lg border">
      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
        <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400 dark:border-[#ffffff38]">
          <tr>
            <th scope="col" className="py-3 px-3 text-center">
              {t("S.NO")}
            </th>
            <OTableHeadOn sort={sort} name={"Customer"} setSort={setSort} />
            {(type === "ongoing" || type === "schedule") ?
              <OTableHeadOn
                sort={sort}
                name={"Mobile Number(customer)"}
                setSort={setSort}
              /> : ""
            }
            <OTableHeadOn
              sort={sort}
              name={t("Service Type")}
              setSort={setSort}
            />
            <OTableHeadOn
              sort={sort}
              name={t("Booking Type")}
              setSort={setSort}
            />

            <OTableHeadOn
              sort={sort}
              name={helpers.ternaryCondition(type == 'schedule', "Scheduled Date & Time", "Booking Date & Time")}

              setSort={setSort}
            />

            <OTableHeadOn
              sort={sort}
              tableClass='text-right'
              name={t("Booking ID")}
              setSort={setSort}
            />
            <OTableHeadOn sort={sort} name={"Assigned Driver"} setSort={setSort} />

            <OTableHeadOn
              sort={sort}
              tableClass='text-right'
              name={"Estimated Earnings"}
              setSort={setSort}
            />
            {helpers.andOperator(type == 'accepted', <OTableHeadOn
              sort={sort}
              name={"Time Left to Pay (min)"}
              setSort={setSort}
            />)}
           <OTableHeadOn
              sort={sort}
              name={"Created At"}
              fieldName={'createdAt'}
              setSort={setSort}
            />

            <OTableHeadOn sort={sort} name={"ACTION"} tableClass={'text-center'} />
          </tr>
        </thead>
        <tbody>
          <AnimatePresence>
            {filteredData?.map((item, idx) => {

              return (
                <motion.tr
                  key={item?._id}
                  initial={{ opacity: 0, y: 5 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.05 }}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <td className="py-3 px-4 text-center border-r font-medium text-gray-900  dark:text-white">
                    {" "}
                    {idx + 1 + 10 * (page - 1)}
                  </td>
                  <td className="py-3 px-4 border-r">
                    {helpers.capitalizeFirstWord(item.userDetails?.fullName)}
                  </td>
                  {(type === "ongoing" || type === "schedule") ? <td className="py-3 px-4 border-r">
                    +{helpers.capitalizeFirstWord(item?.userDetails?.countryCode)}-{helpers.capitalizeFirstWord(item?.userDetails?.mobile)}
                  </td>
                    : ""}
                  <td className="py-3 px-4 border-r">
                    {helpers.capitalizeFirstWord(item?.serviceDetails?.name)}
                  </td>
                  <td className="py-3 px-4 border-r">
                    {helpers.capitalizeFirstWord(item?.bookingType)}
                  </td>

                  <td className="py-3 px-4 border-r">
                    {helpers.ternaryCondition(item?.bookingType == 'immediate', helpers.capitalizeFirstWord(item?.bookingType), helpers.getDateAndTime(item?.dateTime, "MM-DD-YYYY HH:MM A"))}
                  </td>
                  <td className="py-3 px-4 border-r text-right">
                    #{item?.bookingId || "N/A"}
                  </td>
                  <td className="py-3 px-4 border-r">
                    {helpers.capitalizeFirstWord(item?.driverDetails?.fullName)}
                  </td>

                  <td className="py-3 px-4 border-r text-right">
                    {helpers.formattedAmount(item?.spEarning || 0)}
                  </td>
                  {helpers.andOperator(type == 'accepted', <td className="py-3 px-4 border-r">
                   {helpers.ternaryCondition(item?.isPaymentDone,'Paid', <ShowCountDown startTime={item?.acceptedAt} waitSeconds={item?.requestWaitTime} currentTime={item?.currentTime} onComplete={onComplete} />)}
                  </td>)}

                 <td className="py-3 px-4 border-r">
                    {helpers.getDateAndTime(item?.createdAt, "MM-DD-YYYY HH:MM A")}
                  </td>


                  <td className="px-2 py-2 border-l text-center hover:bg-white hover:text-LightBlue dark:hover:bg-transparent flex gap-2 items-center justify-center">

                    {helpers.andOperator(type == 'ongoing',<span className="flex justify-center items-center h-full"
                      title={"Track"}
                      onClick={() => {
                        navigate(`/live-tracking`, { state: item });
                      }}
                    >
                      <FaMapMarkerAlt
                        className="text-slate-600 cursor-pointer"
                        size={18}
                      />
                    </span>)}

                    <span className="flex justify-center items-center h-full"
                      title={"View"}
                      onClick={() => {
                        navigate(`/track-services/view/${item?._id}`);
                      }}>
                      <AiFillEye
                        className="text-slate-600 cursor-pointer"
                        size={23}
                      />
                    </span>
                  </td>

                </motion.tr>
              )
            })}
          </AnimatePresence>

          {isEmpty(filteredData) ? (
            <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
              <td className="py-4 px-6" colSpan={12}>
                {t("O_NO_RECORD_FOUND")}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}

export default OngoingTable